export default "__VITE_ASSET__WvSCeDX___"